import { Theme } from '@/theme';
import Ease from '@CS/utils/Easing';
import { Screen } from '@CS/app/App.styles';
import styled, { css, keyframes } from 'styled-components';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const dash = keyframes`
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }

  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
`;

type LoaderAttributes = {
  $overlay?: boolean;
  opacity?: number;
};

export const LoaderStyle = styled.aside<LoaderAttributes>(
  ({ $overlay, opacity = 0.0 }) => css`
    transform: translateX(-50%);
    max-width: ${Screen.MAX};

    position: fixed;
    display: block;

    height: 100%;
    width: 100%;

    z-index: 2;
    left: 50%;
    top: 0;

    ${$overlay &&
    css`
      background-color: rgb(0 0 0 / ${opacity});
    `}
  `
);

const LoaderContainer = (color = 'white', speed = 2.5, width = 50) => css`
  height: ${width}px;
  width: ${width}px;

  svg {
    animation: ${rotate} ${speed / 1.55}s linear infinite;
    transform-origin: 50%;

    position: absolute;
    margin: auto;

    height: 100%;
    width: 100%;

    bottom: 0;
    right: 0;
    left: 0;
    top: 0;
  }

  circle {
    animation: ${dash} ${speed}s ${Ease.InOut.Sine} infinite;

    stroke-dasharray: 1, 200;
    stroke-linecap: round;
    stroke-dashoffset: 0;
    stroke-width: 5px;
    stroke: ${color};
  }
`;

type SpinnerAttributes = {
  width?: number;
  color?: string;
  speed?: number;
};

export const ImageStyle = styled.div<SpinnerAttributes>(
  ({ color, speed, width }) => css`
    background-color: ${Theme.color.lightPurple};
    background-blend-mode: soft-light;

    background-image: radial-gradient(
      79.23% 20.32% at 50% 51.95%,
      rgb(255 255 255 / 0.5) 0%,
      rgb(255 255 255 / 0) 100%
    );

    justify-content: center;
    flex-direction: column;
    align-items: center;
    display: flex;

    padding: 5px;
    height: 100%;
    width: 100%;

    > div:last-child {
      ${LoaderContainer(color, speed, width)}
      position: relative;
      margin-top: 5dvh;
    }
  `
);

export const SpinnerStyle = styled.div<SpinnerAttributes>(
  ({ color, speed, width }) => css`
    ${LoaderContainer(color, speed, width)}
    position: absolute;
    margin: auto;
    inset: 0;

    &::before {
      padding-top: 100%;
      display: block;
      content: '';
    }
  `
);
